import React from 'react'
import './header.css'
import CTA from './cta'
import DarkMode from './darkmode'
import ME from '../../assets/menew.webp'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (
    <header>
      <div className="container header_container">
        <h2 className="preserve-h5">Hello I'm</h2>
        <h1>Akshat Pawar</h1>
        <h2 className="text-light preserve-h5">Software Developer</h2>
        <CTA />
        <HeaderSocials/>
        <DarkMode/>
        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
}

export default Header